import { ObservableFromFetch } from "../ObservableFromFetch"

export default function SubscriptionPlanCreate(title: string, description: string, username: string) {
  const requestBody: string = JSON.stringify({
    Title: title,
    Description: description,
    ModifiedBy: username
  })

  return ObservableFromFetch<string>("FFOrderSubscriptionPermission/CreateSubscriptionPlan", requestBody)
}
